import React from "react";

const Footer = () => {
  return (
    <div className=" h-9  px-2 py-1 flex items-center justify-center w-full text-base bg-indigo-900 text-white ">
      <span>Copyright &copy; 2024. all are reserved </span>
    </div>
  );
};

export default Footer;
